import { Link, useNavigate } from "react-router-dom";
import { Trash2, Minus, Plus, ShoppingCart, ArrowRight } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatFCFA } from "@/lib/format";
import { EmptyState } from "@/components/common";

export default function CartPage() {
  const { items, setQty, remove, subtotal } = useCart();
  const navigate = useNavigate();

  if (items.length === 0)
    return <EmptyState icon={ShoppingCart} title="Votre panier est vide" subtitle="Parcourez le catalogue et ajoutez des matériaux."
      action={<Link to="/recherche" className="bg-[#C85A32] text-white font-bold px-5 py-2.5 rounded-lg" data-testid="empty-cart-cta">Explorer le catalogue</Link>} />;

  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold text-[#0F172A] mb-5">Mon panier</h1>
      <div className="grid lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 space-y-3">
          {items.map((i) => (
            <div key={i.product_id} className="bg-white border border-slate-200 rounded-xl p-3 flex gap-3 items-center" data-testid={`cart-item-${i.product_id}`}>
              <div className="w-16 h-16 rounded-lg bg-slate-100 overflow-hidden shrink-0">
                {i.image && <img src={i.image} alt="" className="w-full h-full object-cover" />}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-slate-800 line-clamp-1">{i.name}</h3>
                <p className="font-num text-[#C85A32] font-bold text-sm">{formatFCFA(i.price)} <span className="text-slate-400 font-normal">/ {i.unit}</span></p>
              </div>
              <div className="flex items-center border border-slate-300 rounded-lg">
                <button onClick={() => setQty(i.product_id, i.quantity - 1)} className="p-2" data-testid={`cart-minus-${i.product_id}`}><Minus className="w-3.5 h-3.5" /></button>
                <span className="w-8 text-center text-sm font-semibold font-num">{i.quantity}</span>
                <button onClick={() => setQty(i.product_id, i.quantity + 1)} className="p-2" data-testid={`cart-plus-${i.product_id}`}><Plus className="w-3.5 h-3.5" /></button>
              </div>
              <button onClick={() => remove(i.product_id)} className="p-2 text-red-500" data-testid={`cart-remove-${i.product_id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-5 h-fit sticky top-24">
          <h2 className="font-display text-xl font-bold mb-3">Récapitulatif</h2>
          <div className="flex justify-between text-sm mb-2"><span className="text-slate-500">Sous-total</span><span className="font-num font-semibold">{formatFCFA(subtotal)}</span></div>
          <div className="flex justify-between text-sm mb-3"><span className="text-slate-500">Livraison</span><span className="text-slate-400 text-xs">calculée au paiement</span></div>
          <div className="border-t pt-3 flex justify-between font-bold"><span>Total (hors livraison)</span><span className="font-num text-[#C85A32]">{formatFCFA(subtotal)}</span></div>
          <button onClick={() => navigate("/commander")} className="mt-4 w-full bg-[#C85A32] hover:bg-[#A94520] text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 transition active:scale-95" data-testid="checkout-btn">
            Passer la commande <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
